var map = {
	"./5starbaner.png": "0e26",
	"./5starcircleblack.png": "6c44",
	"./5starcirclewhite.png": "52b9",
	"./5starlongblack.png": "dd43",
	"./A63_lottory.webp": "d44c",
	"./H3_ufo711.webp": "66ec",
	"./J1.webp": "e552",
	"./J10.webp": "f7fa",
	"./J11.webp": "2312",
	"./J12.webp": "bbff",
	"./J13.webp": "cf63",
	"./J4.webp": "ddb8",
	"./J8.webp": "d3d2",
	"./J9.webp": "2e1c",
	"./TGONEbanner.png": "150f",
	"./bank-icon.png": "34c9",
	"./banner2.jpg": "db49",
	"./banner3.png": "e5d4",
	"./banner3_.png": "8778",
	"./banner_I12.webp": "9349",
	"./banner_I13.webp": "0744",
	"./banner_default.gif": "bcde",
	"./banner_gt.png": "0e6f",
	"./banner_lottery.webp": "29b8",
	"./banner_nv1.webp": "7030",
	"./banner_nv2.webp": "c211",
	"./banner_wisdom.png": "11e9",
	"./bg-black.jpg": "cf17",
	"./bg-group-lotto.png": "bbf0",
	"./casino/banner/AFBGAMING.png": "1efa",
	"./casino/banner/AFBSPORT.png": "39b5",
	"./casino/banner/AG.png": "6fe0",
	"./casino/banner/ALLBET.png": "28d2",
	"./casino/banner/BET.png": "36ac",
	"./casino/banner/BGLIVE.png": "53a6",
	"./casino/banner/BIGGAMING.png": "4f75",
	"./casino/banner/CHERRYGAMING.png": "c3d6",
	"./casino/banner/CT.png": "a90f",
	"./casino/banner/D88.png": "e716",
	"./casino/banner/DREAMGAMING.png": "94a7",
	"./casino/banner/EBET.png": "d81d",
	"./casino/banner/EVO.png": "33b9",
	"./casino/banner/FantasticLeague.png": "2f7f",
	"./casino/banner/GreyHoundRacing.png": "ccdb",
	"./casino/banner/HOTGRAPH.png": "09eb",
	"./casino/banner/HourseRacing.png": "dbca",
	"./casino/banner/KENO.png": "503c",
	"./casino/banner/N2LIVE.png": "8068",
	"./casino/banner/OBET.png": "177b",
	"./casino/banner/PRAGMATICPLAY.png": "1ea9",
	"./casino/banner/PREETY.png": "7d0a",
	"./casino/banner/PenaltyShootout.png": "38f2",
	"./casino/banner/RNG.png": "17bd",
	"./casino/banner/SA.png": "58ee",
	"./casino/banner/SEXYBCRT.png": "1f96",
	"./casino/banner/VENUS.png": "319e",
	"./casino/banner/WM.png": "205e",
	"./casino/casino_games_img/CasinoChangeName_2bcf2259abb7645eda715df35350cfbe_20211014010020.jpg": "91d8",
	"./casino/casino_games_img/CasinoChangeName_48f04949f85601f7b07937dc47beb23d_20211014005704.png": "bcfc",
	"./casino/casino_games_img/CasinoChangeName_5f8b697878efac1033a311066e92c78f_20211014002435.jpg": "7f60",
	"./casino/casino_games_img/CasinoChangeName_6156aadd1476f6ab518c1fca5b92d8b1_20211014005923.jpg": "a831",
	"./casino/casino_games_img/CasinoChangeName_8499c2436d3ae148406e24eb905ca5fb_20211013235027.png": "0f7a",
	"./casino/casino_games_img/CasinoChangeName_8499c2436d3ae148406e24eb905ca5fb_20211014001423.png": "d6dc",
	"./casino/casino_games_img/CasinoChangeName_d49713e1363a4a5192d5b459c92bb689_20211014003857.jpg": "005e",
	"./casino/casino_games_img/CasinoChangeName_f4366cd6d3f92275b365f304eb8354c5_20211014000144.png": "627a",
	"./casino/casino_games_img/CasinoChangeName_f4366cd6d3f92275b365f304eb8354c5_20211014000534.png": "a133",
	"./casino/icon/slot/ADVPLAY.png": "5d28",
	"./casino/icon/slot/AESLOT.png": "2f34",
	"./casino/icon/slot/AFB777.png": "79a1",
	"./casino/icon/slot/AMBPOKER.png": "4409",
	"./casino/icon/slot/AMBSLOT.png": "ce36",
	"./casino/icon/slot/BGLIVE.png": "c25a",
	"./casino/icon/slot/CQ9.png": "64f3",
	"./casino/icon/slot/FASTSPIN.png": "42c1",
	"./casino/icon/slot/FCSLOT.png": "b303",
	"./casino/icon/slot/FOXSLOT.png": "321e",
	"./casino/icon/slot/HABANERO.png": "0213",
	"./casino/icon/slot/JILI-GPLAY.png": "5e6a",
	"./casino/icon/slot/JILISLOT.png": "5e75",
	"./casino/icon/slot/JOKER.png": "af7a",
	"./casino/icon/slot/KINGMAKER.png": "9822",
	"./casino/icon/slot/LUCKYPOKER.png": "90bf",
	"./casino/icon/slot/MARIO.png": "80ba",
	"./casino/icon/slot/MGPLUSSLOT.png": "b71a",
	"./casino/icon/slot/NETENT2.png": "5204",
	"./casino/icon/slot/PGSLOT.png": "1bf8",
	"./casino/icon/slot/PGSOFTDIRECT.png": "cf32",
	"./casino/icon/slot/PLAYSTAR.png": "ae77",
	"./casino/icon/slot/PRAGMATICPLAY.png": "1023",
	"./casino/icon/slot/REDTIGER.png": "2fee",
	"./casino/icon/slot/SEXYBCRT.png": "bdd2",
	"./casino/icon/slot/SPADEGAMING.png": "504a",
	"./casino/icon/slot/SPINX.png": "8a8f",
	"./casino/icon/slot/YLFISH.png": "39ba",
	"./how-nv24.png": "1c59",
	"./how-pyn.png": "e8ff",
	"./how-v2.webp": "6d41",
	"./ic_deposit.png": "ecc9",
	"./ic_linkaff.png": "628a",
	"./ic_withdraw.png": "5471",
	"./ico-hot.png": "f61d",
	"./line-contact-icon-white.png": "f518",
	"./logo-fifalotto-white4-5starlotto.png": "cea5",
	"./logo-fifalotto-white4-camel.png": "95fa",
	"./logo-fifalotto-white4-giant999.png": "26a5",
	"./logo-fifalotto-white4-gt.png": "d92b",
	"./logo-fifalotto-white4-hanoy88.png": "6df9",
	"./logo-fifalotto-white4-lion.png": "6eac",
	"./logo-fifalotto-white4-lottopyn.png": "c5cb",
	"./logo-fifalotto-white4-nv24.png": "b0c4",
	"./logo-fifalotto-white4-pyn.png": "a5de",
	"./logo-fifalotto-white4-slotpg.png": "a3e3",
	"./logo-fifalotto-white4-tgone.png": "7c8f",
	"./logo-fifalotto-white4-tgone_.png": "6913",
	"./logo-fifalotto-white4-tgonebet.png": "c39c",
	"./logo-fifalotto-white4-ufo711.png": "d663",
	"./logo-fifalotto-white4-wisdombet.png": "5c93",
	"./logo-fifalotto-white4.png": "d9a0",
	"./logo-fifalotto-white44-ufo711.png": "8455",
	"./logo-fifalotto-white5-5starlotto.png": "3e16",
	"./logo-fifalotto-white5-camel.png": "9293",
	"./logo-fifalotto-white5-giant999.png": "53ed",
	"./logo-fifalotto-white5-gt.png": "e7ff",
	"./logo-fifalotto-white5-hanoy88.png": "c5f6",
	"./logo-fifalotto-white5-lion.png": "37c1",
	"./logo-fifalotto-white5-lottopyn.png": "8f4d",
	"./logo-fifalotto-white5-nv24.png": "b854",
	"./logo-fifalotto-white5-pyn.png": "e318",
	"./logo-fifalotto-white5-slotpg.png": "435b",
	"./logo-fifalotto-white5-tgone.png": "c14e",
	"./logo-fifalotto-white5-tgonebet.png": "cde9",
	"./logo-fifalotto-white5-ufo711.png": "645c",
	"./logo-fifalotto-white5-wisdombet.png": "1acf",
	"./logo-fifalotto-white5.png": "b8d2",
	"./new_pyn2.webp": "7279",
	"./newpyn 4.webp": "1bea",
	"./nv24_bg.png": "2b2b",
	"./pyn/page-heading-pattern.png": "a20c",
	"./tgonebet_banner.jpeg": "a962",
	"./userprofile.png": "bb02"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";